import { saveUserSettingsCookie } from '@Components/Utilities/CookieHelper';
import translator from '@Components/Utilities/Translator';

import Combobox from '@Components/MuiWrappers/Combobox';
import Box from '@mui/material/Box';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const LanguageSelector = (props) => {

    const getOptionLabel = (option) => option.Language.LocalTranslatedName;
    const routes = useRecoilValue(atoms.routes);
    const renderOption = (optionsProps, option) => {
        return (
            <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...optionsProps}>
                <div><span>{option.Language.LocalTranslatedName}</span></div>
            </Box>
        );
    };
    const onChange = (event, option, reason, details) => {
        if (reason == 'selectOption') {
            const languageCode = option.LanguageCode;
            if (props.onChange) {
                props.onChange(languageCode);
            } else {
                saveUserSettingsCookie({ languageCode: languageCode, url: routes.SaveUserSettings })
                    .then(data => {
                        window.location.href = data.url;
                    })
                    .catch(error => {
                        console.log('Error saving UserSettings cookie: ', error);
                        window.location.reload(true);
                    });
            }
        }
    };

    return (
        <div className={props.containerClassName}>
            <Combobox
                label={translator.translate('sandhills.tradepubwebsite.mvc.selectyourlanguage')}
                value={props.Languages.filter(l => l.LanguageCode == props.value)[0]}
                options={props.Languages}
                getOptionLabel={getOptionLabel}
                renderOption={renderOption}
                onChange={onChange}
                popperDisablePortal={props.popperDisablePortal}
            />
        </div>
    );
};

export default LanguageSelector;
